import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Paquete } from 'app/models/paquete-model';
import { Services } from 'app/servicios.service';
import { ImagenesModalComponent } from '../imagenes-modal/imagenes-modal.component';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-paquete',
  templateUrl: './paquete.component.html',
  styleUrls: ['./paquete.component.css']
})
export class PaqueteComponent implements OnInit {

  private id : number;
  public paquete: Paquete;
  public loading: boolean;
  public i = 0;
  private isMobile: boolean;
  constructor(public location:Location, public API : Services, public modalCtrl: ModalController) { }

  ngOnInit(): void {
    this.loading = true;
    var tittle = this.location.prepareExternalUrl(this.location.path());
    tittle = tittle.replace('/paquete/', '');
    this.id = Number.parseInt(tittle);
    console.log(this.id);
    this.API.getPaquete(this.id).subscribe(data => {
      this.paquete = data;
      console.log(this.paquete.Descripcion);
      this.loading = false;
    });
    this.isMobile = this.getIsMobile();
    window.onresize = () => {
      this.isMobile = this.getIsMobile();
    };
  }

  getIsMobile(): boolean {
    const w = document.documentElement.clientWidth;
    const breakpoint = 850;
    if (w < breakpoint) {
      return true;
    } else {
      return false;
    }
  }

  async verImagenes(i) {
    if (!this.isMobile) {
      const ModalImagenes = await this.modalCtrl.create({
        component: ImagenesModalComponent,
        componentProps: {
          something: this.paquete.Imagenes,
          index: i,
          other: {couldAlsoBeAnObject: true}
       },
        cssClass: 'custom-modal',
      });
      ModalImagenes.present();
    }
  }

}
